import TotalRevenueModule from "./totalRevenueModule";
import TotalRevenueSagas from "./redux/totalRevenueSagas";
import TotalRevenueReducer from "./redux/totalRevenueReducer";

export default {
  Component: TotalRevenueModule,
  moduleName: "totalRevenue",
  saga: TotalRevenueSagas(),
  reducer: TotalRevenueReducer
};
